export class FileGroupUserEntity {

    id: number
    groupId: number;
    userId: number;

constructor (){}
}
